import objMiniApp from '../utils/MiniApp/MiniApp';
//MINI: Added MiniApp helper class
const attempt = (func) => {
  try {
    return func();
  } catch (err) {
    console.error(err);
    // intentional swallowing of non functional error
  }
};

const MiniAppEvents = {
  sendMessage: (data) => {
    attempt(() => {
      objMiniApp.send(data);
    });
  },
  readMessage: () => {
    return attempt(() => {
      return objMiniApp.read();
    });
  },
  listenForMessage: (func) => {
    attempt(() => {
      objMiniApp.listenForMessage(func);
    });
  },
  toggleKeyboardOpenPadding: (open, elementID) => {
    attempt(() => {
      objMiniApp.toggleKeyboardOpenPadding(open, elementID);
    });
  },
  downloadBase64FileURL: (url) => {
    return attempt(() => {
      return objMiniApp.downloadBase64FileURL(url);
    });
  },
  isInMiniApp: () => {
    return sessionStorage.getItem('inMiniProgram') === 'true';
  },
  isiOS: () => {
    return sessionStorage.getItem('platform') === 'iOS';
  },
  isAndroid: () => {
    return sessionStorage.getItem('platform') === 'Android';
  },
  hideLoading: () => {
    MiniAppEvents.sendMessage({
      messageType: 'hide_loading',
    });
  },
};

export default MiniAppEvents;
